const url = 'https://divelogbackend.onrender.com/dives/'

export default url